import { portalAction, portalScreenContext } from '../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../app/telemetry/usePortalTelemetry';
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import { FileDto } from "../../app/models/membership/fileDto";
import { ApiRequestStatus } from "../../app/enums/apiRequestStatus";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { Paper, Button, Box, Grid, Typography } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import React from "react";
import { formatBytes, getLocalDateWithTimeInString } from "../../app/utils/util";
import { useMsal } from "@azure/msal-react";
import { UserClaims } from "../../app/enums/userClaims";
import { MESSAGE_PROCESSING_DETAILS } from "../../app/utils/constant";
import { useReferenceData } from "../../app/customHooks/useReferenceData";
import { useGetFiles } from "../../app/customHooks/useGetFiles";
import { downloadFileAsync } from "../../app/slices/personSlice";

export default function MyDocumentsForm() {

    const dispatch = useAppDispatch();

    const { files, getDocumentsStatus, downloadStatus } = useAppSelector(state => state.personalDetail);
    const { documentTypes, staticDataStateStatus } = useAppSelector(state => state.ReferenceData);

    const { accounts } = useMsal();

    useEffect(() => {
        if (accounts.length > 0 && accounts[0]?.idTokenClaims) {
            setPersonId(accounts[0].idTokenClaims[UserClaims.EXTENSION_PORTALCRM_PERSONID] as string);
        }
    }, [accounts]);

    const [personId, setPersonId] = useState('');
    const [pageLoading, setPageLoading] = useState(false);

    useReferenceData();
    useGetFiles();

    const downloadFile = (directory: string | null, name: string | null) => {
        if (directory !== null && name !== null) {
            setPageLoading(true);
            dispatch(downloadFileAsync({ directory: directory, fileName: name })).then((response: any) => {
                const url = window.URL.createObjectURL(new Blob([response.payload], { type: 'application/octet-stream' }));

                const link = document.createElement('a');
                link.href = url;
                link.download = response.meta.arg.fileName;

                document.body.appendChild(link);

                link.click();
                link.remove();

                window.URL.revokeObjectURL(url);
                setPageLoading(false);
            });
        }
    }

    usePortalScreen(portalScreenContext('MyDocumentsForm'), undefined, !((pageLoading === true
        || staticDataStateStatus === ApiRequestStatus.Pending
        || getDocumentsStatus === ApiRequestStatus.Pending
        || downloadStatus === ApiRequestStatus.Pending)));

        if (pageLoading === true
        || staticDataStateStatus === ApiRequestStatus.Pending
        || getDocumentsStatus === ApiRequestStatus.Pending
        || downloadStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return (
        <>
            <Box sx={{ flexGrow: 1 }} component={Paper}>
                <Grid container rowSpacing={4}>

                    <Grid size={{ xs: 12 }}></Grid>

                    <Grid size={{ xs: 12 }}>
                        <Typography variant='h3' textAlign={"center"}>My documents</Typography>
                    </Grid>

                    <Grid size={{ xs: 12 }}></Grid>

                </Grid>

                <Grid container component={Paper} sx={{
                    backgroundColor: '#616161',
                    color: "#fff",
                    pt: 2,
                    pb: 2
                }}>

                    <Grid size={{ xs: 0.5 }}></Grid>

                    <Grid size={{ xs: 4.5 }}>
                        File name
                    </Grid>

                    <Grid size={{ xs: 0.5 }}></Grid>

                    <Grid size={{ xs: 1.5 }}>
                        Document type
                    </Grid>

                    <Grid size={{ xs: 0.5 }}></Grid>

                    <Grid size={{ xs: 1 }}>
                        File size
                    </Grid>

                    <Grid size={{ xs: 0.5 }}></Grid>

                    <Grid size={{ xs: 2 }}>
                        Modified date
                    </Grid>

                    <Grid size={{ xs: 1 }}></Grid>

                </Grid>

                {(files === undefined || files == null || files?.length === 0) &&
                    <Grid container component={Paper} sx={{
                        textAlign: 'left',
                        alignItems: 'center'
                    }}>

                        <Grid size={{ xs: 12 }}></Grid>
                        <br />

                        <Grid size={{ xs: 12 }} sx={{
                            textAlign: 'center'
                        }}>
                            No documents found.
                        </Grid>

                        <Grid size={{ xs: 12 }}></Grid>
                        <br />

                    </Grid>
                }

                {files?.map((item: FileDto, index: number) => (
                    <React.Fragment key={index}>
                        <Grid container component={Paper} sx={{
                            alignItems: 'center'
                        }}>
                            <Grid size={{ xs: 0.5 }}></Grid>

                            <Grid size={{ xs: 4.5 }}>
                                {`${item.name}`}
                            </Grid>

                            <Grid size={{ xs: 0.5 }}></Grid>

                            <Grid size={{ xs: 1.5 }}>
                                {item.tags !== null &&
                                    documentTypes?.find(x => x.code === item.tags?.FILE_TYPE)?.publicDisplayName}
                            </Grid>

                            <Grid size={{ xs: 0.5 }}></Grid>

                            <Grid size={{ xs: 1 }}>
                                {item.size && item.size !== null && formatBytes(item.size)}
                            </Grid>

                            <Grid size={{ xs: 0.5 }}></Grid>

                            <Grid size={{ xs: 2 }}>
                                {item.modifiedDate && item.modifiedDate !== null &&
                                    getLocalDateWithTimeInString(new Date(item.modifiedDate))}
                            </Grid>

                            <Grid size={{ xs: 1 }} sx={{ padding: 1 }}>
                                <Button variant="outlined" sx={{
                                    '& .MuiButton-startIcon': {
                                        marginRight: '0',
                                        marginLeft: '0'
                                    },
                                    minWidth: '0'
                                }} startIcon={<DownloadIcon />}
                                    onClick={portalAction(portalScreenContext('MyDocumentsForm'), 'MyDocumentsForm.onClick.downloadFile', () => downloadFile(item.directory, item.name))} >
                                </Button>
                            </Grid>

                        </Grid>
                    </React.Fragment>
                ))}

            </Box>
        </>
    );
}
